import './Report.less';
import {
  Checkbox,
  DatePicker,
  Dropdown,
  Form,
  message,
  Modal,
  Select,
  Tooltip,
  TreeSelect,
  Upload,
} from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/lib/upload/interface';
import { useAppSelector } from 'app/hooks';
import axios from 'axios';
import jobService from 'services/jobService';
import { ArrowDownIcon } from 'components/Icons';
import { RevxButton } from 'components/RevxButton';
import { JobUIStatusEnum, JobWorkflowStatusEnum } from 'domains/workspaceDomain';
import { ExportReportType } from 'domains/appDomain';
import { useOrg, usePage, useUser } from 'hooks';
import moment, { Moment } from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { PlatformRoleEnum } from 'domains/roleDomain';
import cs from 'classnames';
import { DataNode } from 'rc-tree-select/lib/interface';
import { isSourcer, isSupplier } from 'utils/rbac';

const { COMMON, TRANSACTION, PIPELINE } = ExportReportType;

type ReportPeriod = {
  period: string;
  from: string;
  to: string;
  tag: string;
};

const PERIODS: ReportPeriod[] = [
  { period: 'P-6', from: '07/17/2022', to: '08/13/2022', tag: 'FY-2022' },
  { period: 'P-7', from: '08/14/2022', to: '09/10/2022', tag: 'FY-2022' },
  { period: 'P-8', from: '09/11/2022', to: '10/08/2022', tag: 'FY-2022' },
  { period: 'P-9', from: '10/09/2022', to: '11/05/2022', tag: 'FY-2022' },
  { period: 'P-10', from: '11/06/2022', to: '12/03/2022', tag: 'FY-2022' },
  { period: 'P-11', from: '12/04/2022', to: '12/31/2022', tag: 'FY-2022' },
  { period: 'P-12', from: '01/01/2023', to: '01/28/2023', tag: 'FY-2022' },
  { period: 'P-13', from: '01/29/2023', to: '02/25/2023', tag: 'FY-2022' },
  { period: 'P-1', from: '02/26/2023', to: '03/25/2023', tag: 'FY-2023' },
  { period: 'P-2', from: '03/26/2023', to: '04/22/2023', tag: 'FY-2023' },
  { period: 'P-3', from: '04/23/2023', to: '05/20/2023', tag: 'FY-2023' },
  { period: 'P-4', from: '05/21/2023', to: '06/17/2023', tag: 'FY-2023' },
  { period: 'P-5', from: '06/18/2023', to: '07/15/2023', tag: 'FY-2023' },
  { period: 'P-6', from: '07/16/2023', to: '08/12/2023', tag: 'FY-2023' },
  { period: 'P-7', from: '08/13/2023', to: '09/09/2023', tag: 'FY-2023' },
  { period: 'P-8', from: '09/10/2023', to: '10/07/2023', tag: 'FY-2023' },
  { period: 'P-9', from: '10/08/2023', to: '11/04/2023', tag: 'FY-2023' },
  { period: 'P-10', from: '11/05/2023', to: '12/02/2023', tag: 'FY-2023' },
  { period: 'P-11', from: '12/03/2023', to: '12/30/2023', tag: 'FY-2023' },
  { period: 'P-12', from: '12/31/2023', to: '01/27/2024', tag: 'FY-2023' },
  { period: 'P-13', from: '01/28/2024', to: '02/24/2024', tag: 'FY-2023' },
  { period: 'P-1', from: '02/25/2024', to: '03/23/2024', tag: 'FY-2024' },
  { period: 'P-2', from: '03/24/2024', to: '04/20/2024', tag: 'FY-2024' },
  { period: 'P-3', from: '04/21/2024', to: '05/18/2024', tag: 'FY-2024' },
  { period: 'P-4', from: '05/19/2024', to: '06/15/2024', tag: 'FY-2024' },
  { period: 'P-5', from: '06/16/2024', to: '07/13/2024', tag: 'FY-2024' },
  { period: 'P-6', from: '07/14/2024', to: '08/10/2024', tag: 'FY-2024' },
  { period: 'P-7', from: '08/11/2024', to: '09/07/2024', tag: 'FY-2024' },
  { period: 'P-8', from: '09/08/2024', to: '10/05/2024', tag: 'FY-2024' },
  { period: 'P-9', from: '10/06/2024', to: '11/02/2024', tag: 'FY-2024' },
  { period: 'P-10', from: '11/03/2024', to: '11/30/2024', tag: 'FY-2024' },
  { period: 'P-11', from: '12/01/2024', to: '12/28/2024', tag: 'FY-2024' },
  { period: 'P-12', from: '12/29/2024', to: '01/25/2025', tag: 'FY-2024' },
  { period: 'P-13', from: '01/26/2025', to: '02/22/2025', tag: 'FY-2024' },
  { period: 'P-1', from: '02/23/2025', to: '03/22/2025', tag: 'FY-2025' },
  { period: 'P-2', from: '03/23/2025', to: '04/19/2025', tag: 'FY-2025' },
  { period: 'P-3', from: '04/20/2025', to: '05/17/2025', tag: 'FY-2025' },
  { period: 'P-4', from: '05/18/2025', to: '06/14/2025', tag: 'FY-2025' },
  { period: 'P-5', from: '06/15/2025', to: '07/12/2025', tag: 'FY-2025' },
  { period: 'P-6', from: '07/13/2025', to: '08/09/2025', tag: 'FY-2025' },
  { period: 'P-7', from: '08/10/2025', to: '09/06/2025', tag: 'FY-2025' },
  { period: 'P-8', from: '09/07/2025', to: '10/04/2025', tag: 'FY-2025' },
  { period: 'P-9', from: '10/05/2025', to: '11/01/2025', tag: 'FY-2025' },
  { period: 'P-10', from: '11/02/2025', to: '11/29/2025', tag: 'FY-2025' },
  { period: 'P-11', from: '11/30/2025', to: '12/27/2025', tag: 'FY-2025' },
  { period: 'P-12', from: '12/28/2025', to: '01/24/2026', tag: 'FY-2025' },
  { period: 'P-13', from: '01/25/2026', to: '02/28/2026', tag: 'FY-2025' },
  { period: 'P-1', from: '03/01/2026', to: '03/28/2026', tag: 'FY-2026' },
  { period: 'P-2', from: '03/29/2026', to: '04/25/2026', tag: 'FY-2026' },
  { period: 'P-3', from: '04/26/2026', to: '05/23/2026', tag: 'FY-2026' },
  { period: 'P-4', from: '05/24/2026', to: '06/20/2026', tag: 'FY-2026' },
  { period: 'P-5', from: '06/21/2026', to: '07/18/2026', tag: 'FY-2026' },
  { period: 'P-6', from: '07/19/2026', to: '08/15/2026', tag: 'FY-2026' },
  { period: 'P-7', from: '08/16/2026', to: '09/12/2026', tag: 'FY-2026' },
  { period: 'P-8', from: '09/13/2026', to: '10/10/2026', tag: 'FY-2026' },
  { period: 'P-9', from: '10/11/2026', to: '11/07/2026', tag: 'FY-2026' },
  { period: 'P-10', from: '11/08/2026', to: '12/05/2026', tag: 'FY-2026' },
  { period: 'P-11', from: '12/06/2026', to: '01/02/2027', tag: 'FY-2026' },
  { period: 'P-12', from: '01/03/2027', to: '01/30/2027', tag: 'FY-2026' },
  { period: 'P-13', from: '01/31/2027', to: '02/27/2027', tag: 'FY-2026' },
  { period: 'P-1', from: '02/28/2027', to: '03/27/2027', tag: 'FY-2027' },
  { period: 'P-2', from: '03/28/2027', to: '04/24/2027', tag: 'FY-2027' },
  { period: 'P-3', from: '04/25/2027', to: '05/22/2027', tag: 'FY-2027' },
  { period: 'P-4', from: '05/23/2027', to: '06/19/2027', tag: 'FY-2027' },
  { period: 'P-5', from: '06/20/2027', to: '07/17/2027', tag: 'FY-2027' },
  { period: 'P-6', from: '07/18/2027', to: '08/14/2027', tag: 'FY-2027' },
  { period: 'P-7', from: '08/15/2027', to: '09/11/2027', tag: 'FY-2027' },
  { period: 'P-8', from: '09/12/2027', to: '10/09/2027', tag: 'FY-2027' },
  { period: 'P-9', from: '10/10/2027', to: '11/06/2027', tag: 'FY-2027' },
  { period: 'P-10', from: '11/07/2027', to: '12/04/2027', tag: 'FY-2027' },
  { period: 'P-11', from: '12/05/2027', to: '01/01/2028', tag: 'FY-2027' },
  { period: 'P-12', from: '01/02/2028', to: '01/29/2028', tag: 'FY-2027' },
  { period: 'P-13', from: '01/30/2028', to: '02/26/2028', tag: 'FY-2027' },
];

function convertToTreeSelectOptions(periods: ReportPeriod[]): DataNode[] {
  const options: DataNode[] = [];
  for (const period of periods) {
    const yearTag = period.tag;
    let yearNode = options.find((option) => option.value === yearTag);
    if (!yearNode) {
      yearNode = {
        value: yearTag,
        title: yearTag,
        children: [],
        selectable: false,
        key: yearTag,
      };
      options.push(yearNode);
    }
    const title = `${period.period} (${period.from} - ${period.to})`;
    const periodNode: DataNode = {
      value: period as any,
      title,
      key: title,
    };
    if (yearNode && yearNode.children) {
      yearNode.children.push(periodNode);
    }
  }
  return options;
}
const treeSelectOptions = convertToTreeSelectOptions(PERIODS);

// Current Status reports on the workspace status tabs rather than on raw workflow statuses, so
// every box carries the tab it stands for. Completed has no tab of its own - a sourcer has no
// Completed circle, and completed jobs are listed under Invoicing - so it has none.
const statusList: {
  label: string;
  value: string;
  tab?: JobUIStatusEnum;
  /** Exists only as a workspace tab, so a date-range report has nothing to filter on for it. */
  tabOnly?: boolean;
  supplierOnly?: boolean;
}[] = [
  { label: 'Completed', value: JobWorkflowStatusEnum.COMPLETED },
  {
    label: 'Invoicing',
    value: JobWorkflowStatusEnum.INVOICING,
    tab: JobUIStatusEnum.INVOICING,
  },
  {
    label: 'Delivered',
    value: JobWorkflowStatusEnum.DELIVERED,
    tab: JobUIStatusEnum.SHIPPING,
  },
  {
    label: 'In Production',
    value: JobWorkflowStatusEnum.IN_PRODUCTION,
    tab: JobUIStatusEnum.IN_PRODUCTION,
  },
  {
    label: 'Proofing',
    value: JobWorkflowStatusEnum.PREPARE_PROOF,
    tab: JobUIStatusEnum.PROOFING,
  },
  // Billing is a supplier-only circle and has no workflow status of its own, so it is offered only
  // while Current Status is on - a date-range report has nothing to filter on for it.
  {
    label: 'Billing',
    value: JobUIStatusEnum.BILLING,
    tab: JobUIStatusEnum.BILLING,
    tabOnly: true,
    supplierOnly: true,
  },
];

const pipelineLabelCol = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const EXPORT_REPORT_DATE_TYPE = 'MM/DD/YYYY';


enum FORM_FIELD {
  ORG_IDS = 'orgIds',
  STATUS = 'status',
  DATE_RANGE = 'dateRange',
  TRANSACTION_DATE_RANGE = 'transactionDateRange',
  PIPELINE_DATE_RANGE = 'pipelineDateRange',
}
const {
  ORG_IDS,
  PIPELINE_DATE_RANGE,
  TRANSACTION_DATE_RANGE,
  DATE_RANGE,
  STATUS,
} = FORM_FIELD;

enum AlbertsonBillingReportType {
  BILLING = 'BILLING',
  BILLING_MARKUP_MARGIN = 'BILLING_MARKUP_MARGIN',
  UPLOAD_INVOICE_NUMBER = 'UPLOAD_INVOICE_NUMBER',
}

export const Report: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const orgs = useAppSelector((state) => state.org.list);
  const org = useOrg();
  const user = useUser();
  const [form] = Form.useForm();
  const { isWorkspacePage, isPlatformPage } = usePage();
  const isAlbersonOrg = useMemo(() => {
    return [40, 41, 42, 43, 309, 885].includes(org?.id || 0);
  }, [org?.id]);

  const showReportTypeSelector = isSourcer(user);

  const isAdmin = user?.platformRole === PlatformRoleEnum.BackendSystemAdmin;
  const [albertsonReportType, setAlbertsonReportType] =
    useState<AlbertsonBillingReportType | undefined>();
  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const [invoiceFileList, setInvoiceFileList] = useState<UploadFile[]>([]);
  const [invoiceUploading, setInvoiceUploading] = useState(false);
  const [invoiceDownloading, setInvoiceDownloading] = useState(false);
  // "Current Status" reports on whatever sits in the selected statuses right now, so it
  // replaces the date range instead of narrowing it.
  const [currentStatusOnly, setCurrentStatusOnly] = useState(false);

  const supplier = isSupplier(user);

  const statusOptions = useMemo(
    () =>
      statusList
        // A tab-only box has nothing for a date-range report to filter on, and a supplier-only tab
        // has no circle on a sourcer's workspace to line up with.
        .filter((status) =>
          currentStatusOnly ? !status.supplierOnly || supplier : !status.tabOnly
        )
        .map((status) => {
          if (!currentStatusOnly) return status;
          // Completed has no workspace tab of its own, so there is no count to match; completed
          // jobs reach the report through Invoicing, whose tab lists them.
          if (status.value === JobWorkflowStatusEnum.COMPLETED) {
            return { ...status, disabled: true };
          }
          return status;
        }),
    [currentStatusOnly, supplier]
  );

  const onCurrentStatusChange = (checked: boolean) => {
    setCurrentStatusOnly(checked);
    if (!checked) return;
    form.setFieldsValue({ [DATE_RANGE]: null, period: null });
  };

  const handleDownloadInvoiceTemplate = async () => {
    setInvoiceDownloading(true);
    try {
      const authToken = localStorage.getItem('Authorization') ?? '';
      const url = `${process.env.REACT_APP_API_URL}/payments/quickbooks/invoice/template/download`;
      const response = await axios.get(url, {
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          Accept: '*/*',
          Authorization: authToken,
          'x-tenant-id': org?.id,
        },
      });
      if (!(response.data instanceof Blob)) return;
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'invoice_number_template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch {
      message.error('Failed to download template');
    } finally {
      setInvoiceDownloading(false);
    }
  };

  const handleInvoiceUpload = async () => {
    if (invoiceFileList.length === 0) {
      message.warning('Please select a file first');
      return;
    }
    setInvoiceUploading(true);
    try {
      await jobService.refreshQuickBooksToken();
      const formData = new FormData();
      formData.append('file', invoiceFileList[0] as any);
      const authToken = localStorage.getItem('Authorization') ?? '';
      const url = `${process.env.REACT_APP_API_URL}/payments/quickbooks/invoice/import`;
      const response = await axios.post(url, formData, {
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          Accept: '*/*',
          Authorization: authToken,
          'x-tenant-id': org?.id,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'invoice_import_result.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
      setInvoiceModalVisible(false);
      setInvoiceFileList([]);
      setAlbertsonReportType(undefined);
    } catch {
      message.error('Failed to upload invoice numbers');
    } finally {
      setInvoiceUploading(false);
    }
  };

  useEffect(() => {
    const formValue: { [x in string]: Array<number | string> } = {
      status: [
        JobWorkflowStatusEnum.COMPLETED,
        JobWorkflowStatusEnum.INVOICING,
      ],
      orgIds: [],
    };
    if (org?.id) formValue['orgIds'] = [org.id];
    form.setFieldsValue(formValue);
  }, [form, org?.id]);

  // Keep the ticked boxes to the ones the current mode actually offers: Completed is disabled while
  // Current Status is on (and the defaults above re-seed it on every org change), and Billing only
  // exists while it is on. Both only write when there is something to drop, so neither clears a
  // selection the user made.
  useEffect(() => {
    const selectedStatus: string[] = form.getFieldValue(STATUS) ?? [];
    const dropped = currentStatusOnly
      ? [JobWorkflowStatusEnum.COMPLETED as string]
      : [JobUIStatusEnum.BILLING as string];
    if (!selectedStatus.some((status) => dropped.includes(status))) return;
    form.setFieldsValue({
      [STATUS]: selectedStatus.filter((status) => !dropped.includes(status)),
    });
  }, [form, org?.id, currentStatusOnly]);

  const onFinish = async (
    values: any,
    exportType: ExportReportType,
    billingReportType?: AlbertsonBillingReportType
  ) => {
    const orgIds = values.orgIds;
    const isCurrentStatus = exportType === COMMON && currentStatusOnly;
    const selected: string[] = values.status ?? [];
    // Current Status reports on the workspace tabs, so it sends those instead of workflow statuses;
    // Completed is disabled there and contributes no tab, so it simply drops out.
    const statusFilters = statusList
      .filter((s) => s.tab && selected.includes(s.value))
      .map((s) => s.tab as JobUIStatusEnum);
    // A tab-only box (Billing) is not a workflow status, so it never goes out as one.
    const status: JobWorkflowStatusEnum[] = selected.filter((value) =>
      statusList.some((s) => s.value === value && !s.tabOnly)
    ) as JobWorkflowStatusEnum[];
    if (status.find((s: string) => s === JobWorkflowStatusEnum.PREPARE_PROOF)) {
      status.push(JobWorkflowStatusEnum.PROOF_AWAIT_APPROVAL);
      status.push(JobWorkflowStatusEnum.PROOF_NEED_REVISION);
    }
    if (isCurrentStatus && statusFilters.length === 0) {
      // The form hides inline errors, so this is surfaced as a toast instead.
      message.warning('Please select at least one status');
      return;
    }
    const field = {
      [COMMON]: DATE_RANGE,
      [TRANSACTION]: TRANSACTION_DATE_RANGE,
      [PIPELINE]: PIPELINE_DATE_RANGE,
    }[exportType];
    const dateFrom = isCurrentStatus
      ? undefined
      : (values[field][0] as Moment).format('YYYY-MM-DD');
    const dateTo = isCurrentStatus
      ? undefined
      : (values[field][1] as Moment).format('YYYY-MM-DD');

    const authToken = localStorage.getItem('Authorization') ?? '';
    const url = `${process.env.REACT_APP_API_URL}/jobs/reports`;
    const res = await axios.post(
      url,
      {
        orgIds,
        exportType,
        ...(isCurrentStatus
          ? { currentStatus: true, statusFilters: [...new Set(statusFilters)] }
          : { status, dateFrom, dateTo }),
        ...(billingReportType ? { billingReportType: billingReportType } : {}),
      },
      {
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          Accept: '*/*',
          Authorization: authToken,
        },
      }
    );
    if (!(res.data instanceof Blob)) return;
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = isCurrentStatus
      ? 'job-reports-current-status.xlsx'
      : `job-reports-${dateFrom}-to-${dateTo}.xlsx`;
    link.click();
    setVisible(false);
  };

  /**
   * Whether every required field is filled in. A failed validation marks the field itself through
   * .ant-form-item-has-error, so nothing else has to be said about it here. antd also rejects with
   * `outOfDate` and no errorFields when the form changed while it was validating - nothing is
   * missing in that case, so it is validated once more instead of blocking the download.
   */
  const allRequiredFieldsFilled = async (fields: string[]) => {
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        await form.validateFields(fields);
        return true;
      } catch (error) {
        const errorFields =
          (error as { errorFields?: { name: string[] }[] })?.errorFields ?? [];
        if (errorFields.length > 0) return false;
      }
    }
    return true;
  };

  const triggerReportsDownload = async (
    exportType: ExportReportType,
    billingReportType?: AlbertsonBillingReportType
  ) => {
    const validateFieldsMap = {
      [COMMON]: currentStatusOnly
        ? [ORG_IDS, STATUS]
        : [ORG_IDS, DATE_RANGE],
      [TRANSACTION]: [TRANSACTION_DATE_RANGE],
      [PIPELINE]: [PIPELINE_DATE_RANGE],
    };
    if (!(await allRequiredFieldsFilled(validateFieldsMap[exportType]))) return;
    await onFinish(form.getFieldsValue(), exportType, billingReportType);
  };

  const applyPeriod = (period: any) => {
    form.setFieldsValue({
      dateRange: [
        moment(period.from, EXPORT_REPORT_DATE_TYPE),
        moment(period.to, EXPORT_REPORT_DATE_TYPE),
      ],
    });
  };

  const reportForm = (
    <Form
      form={form}
      className={cs('report-form', { 'report-form-admin': isAdmin })}
      layout="horizontal"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      requiredMark={false}
    >
      <RevxFlexLayout justify="space-between" className="report-wrap">
        <div>
          {showReportTypeSelector && (
            <Form.Item label="Report Type">
              <Select
                placeholder="Select report type"
                value={albertsonReportType}
                onChange={(val) => {
                  setAlbertsonReportType(val);
                  if (val === AlbertsonBillingReportType.UPLOAD_INVOICE_NUMBER) {
                    setInvoiceModalVisible(true);
                  }
                }}
                getPopupContainer={(e) => e as HTMLElement}
              >
                <Select.Option value={AlbertsonBillingReportType.BILLING}>
                  Billing Report
                </Select.Option>
                {isAlbersonOrg && (
                  <Select.Option
                    value={AlbertsonBillingReportType.BILLING_MARKUP_MARGIN}
                  >
                    Billing Report - Markup/Margin
                  </Select.Option>
                )}
                <Select.Option
                  value={AlbertsonBillingReportType.UPLOAD_INVOICE_NUMBER}
                >
                  Upload Invoice Number
                </Select.Option>
              </Select>
            </Form.Item>
          )}
          {(!showReportTypeSelector || (albertsonReportType && albertsonReportType !== AlbertsonBillingReportType.UPLOAD_INVOICE_NUMBER)) && (
            <>
              <Form.Item
                label="Organization"
                name={ORG_IDS}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  getPopupContainer={(e) => {
                    return e as HTMLElement;
                  }}
                  mode="multiple"
                >
                  {orgs.map((org) => (
                    <Select.Option value={org.id} key={org.id}>
                      {org.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {isAlbersonOrg && (
                <Form.Item label="Period" name="period">
                  <TreeSelect
                    showSearch
                    dropdownStyle={{
                      maxHeight: 400,
                      minWidth: 270,
                    }}
                    placeholder="Please select"
                    allowClear
                    disabled={currentStatusOnly}
                    treeDefaultExpandAll
                    onChange={applyPeriod}
                    treeData={treeSelectOptions}
                    getPopupContainer={(e) => {
                      return e as HTMLElement;
                    }}
                  />
                </Form.Item>
              )}
              <Form.Item label="Date" required={!currentStatusOnly}>
                <Form.Item
                  name={DATE_RANGE}
                  rules={[{ required: !currentStatusOnly }]}
                  noStyle
                >
                  <DatePicker.RangePicker
                    format={EXPORT_REPORT_DATE_TYPE}
                    disabled={currentStatusOnly}
                    onFocus={() => form.setFieldsValue({ period: null })}
                    getPopupContainer={(e) => {
                      return e as HTMLElement;
                    }}
                  />
                </Form.Item>
                {/* On its own line: sharing the row with the picker squeezed the dates. */}
                <Checkbox
                  className="current-status-checkbox"
                  checked={currentStatusOnly}
                  onChange={(e) => onCurrentStatusChange(e.target.checked)}
                >
                  Current Status
                </Checkbox>
              </Form.Item>
              <Form.Item
                label="Status"
                name={STATUS}
                rules={[{ required: currentStatusOnly }]}
              >
                <Checkbox.Group options={statusOptions} />
              </Form.Item>
              <Form.Item wrapperCol={{ span: 12, offset: 8 }}>
                <RevxButton
                  type="primary"
                  brandOrange
                  className="report-form-btn"
                  onClick={() =>
                    triggerReportsDownload(COMMON, albertsonReportType)
                  }
                >
                  Download
                </RevxButton>
              </Form.Item>
            </>
          )}
        </div>
        {isAdmin && (
          <RevxFlexLayout className="pipeline-report" wrap="wrap">
            <RevxFlexLayout
              className="download-item"
              direction="column"
              justify="justify-center"
            >
              <div className="report-form-title">Job Pipeline Report</div>
              <Form.Item
                label="Date"
                name={PIPELINE_DATE_RANGE}
                rules={[{ required: true }]}
                {...pipelineLabelCol}
              >
                <DatePicker.RangePicker
                  format={EXPORT_REPORT_DATE_TYPE}
                  getPopupContainer={(e) => {
                    return e as HTMLElement;
                  }}
                />
              </Form.Item>
              <RevxButton
                type="primary"
                brandOrange
                className="report-form-btn"
                onClick={() => triggerReportsDownload(PIPELINE)}
              >
                Download
              </RevxButton>
            </RevxFlexLayout>
            <RevxFlexLayout className="download-item" direction="column">
              <div className="report-form-title">Transaction Report</div>
              <Form.Item
                label="Date"
                name={TRANSACTION_DATE_RANGE}
                rules={[{ required: true }]}
                {...pipelineLabelCol}
              >
                <DatePicker.RangePicker
                  format={EXPORT_REPORT_DATE_TYPE}
                  getPopupContainer={(e) => {
                    return e as HTMLElement;
                  }}
                />
              </Form.Item>
              <RevxButton
                type="primary"
                brandOrange
                className="report-form-btn"
                onClick={() => triggerReportsDownload(TRANSACTION)}
              >
                Download
              </RevxButton>
            </RevxFlexLayout>
          </RevxFlexLayout>
        )}
      </RevxFlexLayout>
    </Form>
  );
  const available = isWorkspacePage || isPlatformPage;
  return (
    <>
      <Dropdown
        overlay={reportForm}
        placement="bottomRight"
        getPopupContainer={(e) => {
          return e as HTMLElement;
        }}
        trigger={['click']}
        visible={visible}
        onVisibleChange={setVisible}
        disabled={!available}
      >
        <div className="report">
          <Tooltip title={available ? '' : 'Only available in Workspace'}>
            {t('header.report')} <ArrowDownIcon />
          </Tooltip>
        </div>
      </Dropdown>
      <Modal
        title="Upload Invoice Number"
        visible={invoiceModalVisible}
        onCancel={() => {
          setInvoiceModalVisible(false);
          setInvoiceFileList([]);
          setAlbertsonReportType(undefined);
        }}
        footer={null}
        destroyOnClose
      >
        <div style={{ marginBottom: 16 }}>
          <p style={{ marginBottom: 8 }}>
            Step 1: Download the invoice number import template
          </p>
          <RevxButton
            brandOrange
            icon={<DownloadOutlined />}
            loading={invoiceDownloading}
            onClick={handleDownloadInvoiceTemplate}
          >
            Download Template
          </RevxButton>
        </div>
        <div>
          <p style={{ marginBottom: 8 }}>
            Step 2: Fill in the template and upload (Excel files only)
          </p>
          <Upload
            accept=".xlsx,.xls"
            maxCount={1}
            fileList={invoiceFileList}
            beforeUpload={(file) => {
              const isExcel =
                file.type ===
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'application/vnd.ms-excel';
              if (!isExcel) {
                message.error('Only Excel files (.xlsx, .xls) are allowed');
                return false;
              }
              setInvoiceFileList([file]);
              return false;
            }}
            onRemove={() => setInvoiceFileList([])}
          >
            <RevxButton icon={<UploadOutlined />}>Select File</RevxButton>
          </Upload>
          {invoiceFileList.length > 0 && (
            <RevxButton
              type="primary"
              brandOrange
              loading={invoiceUploading}
              style={{ marginTop: 12 }}
              onClick={handleInvoiceUpload}
            >
              Upload
            </RevxButton>
          )}
        </div>
      </Modal>
    </>
  );
};
